
import { motion } from 'framer-motion';

const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1F2937] text-gray-300 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div className="space-y-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/c7ca1cd9-942c-41a6-a724-9a8ab077dd81.png" 
              alt="Zimmetle.com Logo" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm leading-relaxed">
              IT envanter yönetiminde dijital dönüşümün öncüsü. ManageEngine ServiceDesk Plus ile tam entegre çözümler.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-lg">Çözümler</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="hover:text-[#FF6B35] transition-colors cursor-pointer text-left"
                >
                  Dijital Doğrulama
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="hover:text-[#FF6B35] transition-colors cursor-pointer text-left"
                >
                  Akıllı Form Oluşturucu
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('integration')}
                  className="hover:text-[#FF6B35] transition-colors cursor-pointer text-left"
                >
                  Entegrasyonlar
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('roadmap')}
                  className="hover:text-[#FF6B35] transition-colors cursor-pointer text-left"
                >
                  Yol Haritası
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-lg">Bülten</h4>
            <p className="text-sm mb-4">Yeniliklerden haberdar olun</p>
            <div className="flex">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-l-lg text-white text-sm focus:outline-none focus:border-[#FF6B35]"
              />
              <button className="px-4 py-2 bg-[#FF6B35] text-white rounded-r-lg hover:bg-[#FF5722] transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-fill"></i>
              </button>
            </div>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-all cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-all cursor-pointer">
                <i className="ri-github-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-gray-400">
            © 2025 Zimmetle.com. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-6 text-sm">
            <a href="#" className="hover:text-[#FF6B35] transition-colors">Gizlilik Politikası</a>
            <a href="#" className="hover:text-[#FF6B35] transition-colors">Kullanım Koşulları</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow" className="hover:text-[#FF6B35] transition-colors">
              Powered by WOTECH
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
